export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const emailRecipientRegex =
  /^(?=.{1,64}$)(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))$/;

const emailDomainRegex =
  /^(?=.{1,253}$)((\[(\d{1,3}\.){3}\d{1,3}\])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;

export const isValidEmail = (email: string): boolean => {
  const arr = email.split("@");
  if (
    arr.length === 2 &&
    emailRecipientRegex.test(arr[0]!) &&
    emailDomainRegex.test(arr[1]!)
  ) {
    return true;
  }
  return false;
};
